import React from "react";
import { Icon } from "semantic-ui-react";
import getTaskTitle from "../../utils/getTaskTitle";

const TaskDescription = ({ task }) => (
  <div>
    {task.status === "closed" ? <Icon name="check circle" /> : null} {getTaskTitle(task)}
  </div>
);

export default TaskDescription;



// WEBPACK FOOTER //
// ./src/component/TasksListComponents/TaskDescription.js